import {caseInsensitiveSort} from "../../common/Utils";
import "../Styles/AdminListings.css";

export const auditReportColumns = [
	{
		name: 'User Name',
		selector: row => row.userName,
        sortable: true,
		wrap: true,
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.userName? row.userName: ""),
	},
	{
		name: 'Company Name',
		selector: row => row.careFacilityName,
        sortable: true,
		wrap: true,
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.careFacilityName? row.careFacilityName:""),
	},
	{
		name: 'Browser Name',
		selector: row => row.browserName,
        sortable: true,
		wrap: true,
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.browserName? row.browserName: ""),
	},
	{
		name: 'Version',
		selector: row => <div style={{align:"center", textAlign:"center", alignContent:"center"}}>{row.browserVersion}</div>,
        sortable: true,
		center:true,
		align:"center",
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		wrap: true,
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.browserVersion? row.browserVersion: ""),
	},
	{
		name: 'IP',
        sortable: true,
		selector: row => row.remoteAddress,
		wrap: true,
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.remoteAddress? row.remoteAddress: ""),
	},
	{
		name: 'Login Date/Time',
        sortable: true,
		selector: row => row.logDate,
		wrap: true,
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.logDate? row.logDate: ""),
	},
	{
		name: 'User Type',
        sortable: true,
		selector: row => row.userType,
		wrap: true,
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.userType? row.userType: ""),
	},
];

export const auditReportExcelColumns = [
    {
		header: 'User Name',
		key: 'userName',
	},
	{
		header: 'Company Name',
		key: 'careFacilityName',
	},
	{
		header: 'Browser Name',
		key: 'browserName',
	},
	{
		header: 'Version',
		key: 'browserVersion',
	},
	{
		header: 'IP',
		key: 'remoteAddress',
	},
	{
		header: 'Login Date/Time',
		key: 'logDate',
	},
	{
		header: 'User Type',
		key: 'userType',
	}
];